import { render, staticRenderFns } from "./ColorPicker.vue?vue&type=template&id=51c55516&scoped=true"
import script from "./ColorPicker.vue?vue&type=script&lang=js"
export * from "./ColorPicker.vue?vue&type=script&lang=js"
import style0 from "./ColorPicker.vue?vue&type=style&index=0&id=51c55516&prod&lang=scss&scoped=true"
import style1 from "./ColorPicker.vue?vue&type=style&index=1&id=51c55516&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51c55516",
  null
  
)

export default component.exports